<template>
  <div class="loading-container">
    <h1>Sapori miei</h1>
    <div class="animated-border">
      <img src="@/assets/fork_knife_circle.svg" class="fork-knife-circle" alt="Fork and Knife Circle">
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";

export default {
  mounted() {
    const forkKnifeCircle = this.$el.querySelector(".fork-knife-circle");

    // Imposta le proprietà di base per l'animazione
    gsap.set(forkKnifeCircle, { transformOrigin: "center" });

    // Crea un'animazione di scalatura
    gsap.to(forkKnifeCircle, { duration: 1, scale: 1.2, repeat: -1, yoyo: true });
  }
};
</script>

<style scoped>
.loading-container {
  position: absolute;
  z-index: 1000;
  top: 0px;
  left:0px;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--background-color);
}
.loading-container h1{
    color: var(--text-color);
    font-size: 40px;
    position:absolute;
    bottom: 20vh;
}

.animated-border {
  position: relative;
  top: -10vh;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  animation: rotate-box-shadow 2s infinite linear;
}

@keyframes rotate-box-shadow {
  0% {
    box-shadow: 0 0 0 0px #aaa;
  }
  50% {
    box-shadow: 0 0 0 10px #ddd;
  }
  100% {
    box-shadow: 0 0 0 0px #aaa;
  }
}

.fork-knife-circle {
  width: 100%;
  height: auto;
}
</style>
